import { render } from "./popupAddSection.vue?vue&type=template&id=17830158"
import script from "./popupAddSection.vue?vue&type=script&lang=js"
export * from "./popupAddSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__